import { useDispatch, useSelector } from "react-redux";
import { useEffect, useState } from "react";
import { getAllArticulos } from "../../redux/articulos/articulosAction";
import ArticuloCard from "./articuloCard";
import '../../index.css';

export default function InformesArticulos() {
    const dispatch = useDispatch();
    const articulos = useSelector(state => state.articulos.allArticulos);
    const [articulosAux, setArticulosAux] = useState();
    const [search, setSearch] = useState()


    useEffect(() => {
        dispatch(getAllArticulos())
    }, [dispatch]);

    console.log(articulos);

    const handleChange = (e) => {
        const {value} = e.target;
        console.log(value);
        
        setSearch(value)
    }

    const searchArticulos = () => {
        if(articulosAux === undefined){
            let result = articulos.filter(e => {
               if(e.nombre.toString().toLowerCase().includes(search.toLowerCase())) {
                return e
               }
            })
            console.log(result);
            
            setArticulosAux(result)
        } else {
            let result = articulosAux.filter(e => {
                if(e.nombre.toString().toLowerCase().includes(search.toLowerCase())) {
                 return e
                }
             })
             console.log(result);
             
             setArticulosAux(result)
        }
    }

    const limpiarSearch = () => {
        setArticulosAux(articulos)
    }
    

    return (
        <>
        <div className="bg-custom container-custom">
            <p className="text-orange-500">informes articulos</p>
            <div className="h-[100px] text-orange-500 bg-gray-700">
                <div className="flex justify-center items-center w-[240px] pt-[10px] ml-2">
                    <label className="text-[11pt] font-bold mr-1">Articulo</label>
                    <input
                        className="border border-slate-700 rounded w-44 h-4 text-center text-[10pt] font-semibold text-black bg-sky-200 placeholder-gray-600"
                        type="text"
                        placeholder="Articulo"
                        value={search}
                        onChange={handleChange} 
                    />
                </div> 
                <div className="flex justify-around ml-2 w-[240px]">
                <button className="text-[11pt] font-bold hover:text-orange-300" onClick={searchArticulos}>Buscar</button>  
                <button className="text-[11pt] font-bold hover:text-orange-300" onClick={limpiarSearch}>Limpiar</button>    
                </div>                         
            </div>
            <div>
                <div>
                    <table>
                        <thead>
                            <tr className="text-orange-500 text-[12pt] font-bold border-y border-white">
                                <td className="w-[80px]">Codigo</td>
                                <td className="w-[656px]">Articulo</td>
                                <td className="w-[150px]">Ciclo</td>
                                <td className="w-[180px]">ISBN</td>
                                <td className="w-[100px]">Precio</td>
                            </tr>
                        </thead>
                    </table>
                </div>
                {!articulosAux ? articulos.map(e=> (
                    <ArticuloCard 
                    key={e._id}
                    id={e._id}
                    codArticulo={e.codArticulo}
                    nombre={e.nombre}
                    ciclo={e.ciclo}
                    isbn={e.isbn}
                    precio={e.precio}
                    />
                )) : 
                articulosAux.map(e=> (
                    <ArticuloCard 
                    key={e._id}
                    codArticulo={e.codArticulo}
                    nombre={e.nombre}
                    ciclo={e.ciclo}
                    isbn={e.isbn}
                    precio={e.precio}
                    />
                ))
                }
            </div>
        </div>
        </>
    )
}